import React from 'react';
import { Script } from 'gatsby';

const LuckyOrangeScript = () => {
  return (
    <Script
      src={`https://tools.luckyorange.com/core/lo.js?site-id=${process.env.GATSBY_LUCKY_ORANGE_SITE_ID}`}
      async
      defer
    />
  );
};

export default LuckyOrangeScript;
